import { LoadingButton } from "@mui/lab";
import { FormProvider, RHFFileField, RHFTextField } from "../../common/hook-form";
import DownloadSampleFile from "../../components/DownloadSampleFile";
import { useState } from "react";
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { apiConstants, post } from "../../common/constants";
import { FieldLabel } from "../../common/FilterBar";

function MISCourierUpload() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const methods = useForm();
    const sampleName = 'COURIER_WEIGHTS_MIS_FOR_WEIGHT_DISCREPANCY_SAMPLE';
    const { handleSubmit, reset } = methods;

    const onSubmit = async (data) => {
        setIsSubmitting(true);
        let formData = new FormData();
        formData.append('file', data?.file[0]);
        formData.append('remark', data?.remark);
        try {
            await post(apiConstants.COURIER_MIS_UPLOAD, formData).then((res) => {
                if (res.data.status === "SUCCESS") {
                    enqueueSnackbar("Successfully uploaded!", { variant: 'success' });
                    reset();
                } else {
                    enqueueSnackbar(res.data.errorMsg, { variant: 'error' });
                }
            }).catch((err) => console.log(err));
            setIsSubmitting(false);
        } catch (e) {
            console.error(e);
            setIsSubmitting(false);
        }
    };

    return (
        <Card elevation={0} sx={{ borderRadius: '10px', border: '1px solid #e8e8e8', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
            <Box sx={{ px: 2.5, py: 1.75, borderBottom: '1px solid #f0f0f0' }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1a1a2e' }}>Courier MIS Upload</Typography>
                <Typography sx={{ fontSize: '12px', color: '#9ca3af', mt: '2px' }}>Upload courier weight MIS file to process weight discrepancies in bulk</Typography>
            </Box>
            {/* Feedback item A3: document the expected update cadence for courier MIS uploads. */}
            <Box sx={{ px: 2.5, py: 1.25, bgcolor: '#f8fafc', borderBottom: '1px solid #f0f0f0' }}>
                <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.4px', mb: 0.5 }}>Update frequency</Typography>
                <Box component='ul' sx={{ pl: 2.25, m: 0, '& li': { fontSize: '11.5px', color: '#64748b', lineHeight: 1.5 } }}>
                    <li>Transit weight — Delhivery &amp; Bluedart: <strong>DAILY</strong>; all other couriers: <strong>MONTHLY</strong></li>
                    <li>Courier billed weight — <strong>MONTHLY</strong></li>
                    <li>Courier billed weight slabs — <strong>MONTHLY</strong></li>
                </Box>
            </Box>
            <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
                <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12} sm={6}>
                            <FieldLabel>Upload File</FieldLabel>
                            <RHFFileField name='file' fileType={['xlsx', 'csv']} label="Click to upload MIS file" />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FieldLabel>Remarks</FieldLabel>
                            <RHFTextField name='remark' label="" placeholder="Provide some remarks" fullWidth size="small" InputLabelProps={{ shrink: true }} />
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                <LoadingButton
                                    loading={isSubmitting}
                                    variant="contained"
                                    size="small"
                                    type="submit"
                                    disableElevation
                                    sx={{ fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: 2.5, py: 1, bgcolor: '#1565c0', '&:hover': { bgcolor: '#0d47a1' } }}
                                >
                                    Submit
                                </LoadingButton>
                                <DownloadSampleFile fileName={sampleName} label="Sample" />
                            </Box>
                        </Grid>
                    </Grid>
                </FormProvider>
            </CardContent>
        </Card>
    );
}

export default MISCourierUpload;
